// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"89":"224b5034","254":"14f62eb7","369":"4dde989d","474":"224b5034"}[chunkId] + ".chunk.css";
};